import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import { requests } from "../../../common/RestAPI";
import { base64Encoding, generateQueryParam, getTimestampToDate, sleep } from "../../../common/util";
import { SESSIONSTORAGE } from "../../../value/staticValues";
import { PAGE_URL, PLATFORM_URL } from "../../../value/Url";

import ContentsProps from "../../../interfaceTypes/ContentsProps";

import { ListFilter } from "../../base/table/listTableType";
import { actionMenus, backupRestoreModalContent, categoryFilters, tableHeaders, backupAddModalContent, VmBackupData } from "./BackupData";
import { PopupModalItemType } from "../../base/modal/PopupModal";

import BackupMgmt from "./BackupMgmt";
import { ALERTS, POPUP_TYPE } from "../../../value/type";
import { VmCommandEmptyPackage, VmParse } from "../../../interfaceTypes/VmType";
import BackupSyncModal from "./BackupSyncModal";


export default function BackupMgmtContainer(props:ContentsProps) {
    const { t } = useTranslation();
    const [infoText, setInfoText] = useState('');
    const [infoError, setInfoError] = useState(false);

    const fetchIdRef = useRef(0);
    const [currentPage, setCurrentPage] = useState(0);
    const [pageCount, setPageCount] = useState(0);
    const [totalItemCount, setTotalItemCount] = useState(0);
    const [selectItems, setSelectItems] = useState<VmBackupData[]>([]);
    const [tableData, setTableData] = useState<VmBackupData[]>([]);
    const [refreshYn, setRefreshYn] = useState(false);
    const [showSyncPopupYn, setShowSyncPopupYn] = useState(false);


    const [executeDeleteImageYn, setExecuteDeleteImageYn] = useState(false);
    const [actionResultTitle, setActionResultTitle] = useState("");
    const [actionResultMessage, setActionResultMessage] = useState("");
    const [actionResults, setActionResults] = useState<PopupModalItemType[]>([]);
    const [actionResultCount, setActionResultCount] = useState(0);

    const headers = useMemo(() => tableHeaders, []);
    const navigate = useNavigate();


    useEffect(() => {
        AlertFunction('');

    }, []);

    function AlertFunction(text:string, error=false) {
        setInfoText(text);
        setInfoError(error);
    }

    // TODO Action 결과에 맞는 처리
    useEffect(() => {
        if(actionResults.length === 0) {
            return ;
        }
        if(actionResultMessage && actionResultTitle) {
            const items = actionResults.map((item, index) => {
                return { target: item.target, successYn: item.successYn, reason: item.reason}
            });
            const completeYn = items.length === selectItems.length ? true : false;
            props.showPopupModalCb({
                openYn: true,
                type: POPUP_TYPE.LIST_MESSAGE_COMPLETE_POPUP,
                title: actionResultTitle,
                message: actionResultMessage,
                items: items,
                completeTargetText: t("VM_BACKUP_IMAGE_NAME"),
                code: "COMPLETE",
                cancelButtonYn: false,
                confirmButtonCb: confirmAction,
                completeYn: completeYn
            });

            if(completeYn) {
                props.setLoading(false);
            }
        }
        if(actionResults.length > 0) {
            setActionResultCount(actionResultCount - 1);
        }
    }, [actionResults, actionResultTitle, actionResultMessage]);


    useEffect(() => {
        if(actionResultCount === selectItems.length) {
            props.setLoading(true);
        }
        if(actionResultCount > 0) {
            if(executeDeleteImageYn) {
                setActionResultTitle(t("VM_BACKUP_DELETE_COMPLETE_TEXT"));
                setActionResultMessage(t("MESSAGE_VM_BACKUP_DELETE_COMPLETE_MESSAGE"));
                executeDeleteImage(selectItems[selectItems.length - actionResultCount]);
            }
        }
    }, [actionResultCount, executeDeleteImageYn]);


    function executeResult(target, successYn, reason:string="") {
        const results = actionResults.concat([{target: target, successYn: successYn, reason:reason }]);
        setActionResults(results);
    }


    function executeDeleteImage(item) {
        requests.delete(PLATFORM_URL.VM_BACKUP + "/" + item.vm_backup_id)
        .then((response) => {
            executeResult(item.vm_backup_name, true);
        })
        .catch((error) => {
            executeResult(item.vm_backup_name, false);
        })
    }

    function addBackupImageResult(data) {
        if(data.successYn) {
            AlertFunction(t("MESSAGE_BACKUP_IMAGE_ADD_SUCCESS_MESSAGE"));
            setRefreshYn(true);
        }
    }

    function restoreBackupImageResult(data) {
        if(data.successYn) {
            AlertFunction(t("MESSAGE_BACKUP_IMAGE_RESTORE_SUCCESS_MESSAGE"));
            setRefreshYn(true);
        }
    }
    function confirmAction(code) {
        if(code === "BACKUP_DELETE") {
            setActionResultCount(selectItems.length);
            setExecuteDeleteImageYn(true);
        } else if(code !== "COMPLETE") {
            setActionResultCount(selectItems.length);
        } else {
            setActionResultCount(0);
            setActionResults([]);
            setActionResultMessage("");
            setActionResultTitle("");
            setExecuteDeleteImageYn(false);
            setRefreshYn(true);
            AlertFunction('');
        }
    }

    function clickActionMenu(code) {
        if(code === "BACKUP_ADD") {
            props.showSlideModalCb({...backupAddModalContent, openYn: true, resultCb: addBackupImageResult});
        } else if(code === "BACKUP_DELETE") {
            props.showPopupModalCb({openYn: true,
                                    type: POPUP_TYPE.LIST_MESSAGE_WITH_TITLE_POPUP,
                                    title: t("MESSAGE_BACKUP_IMAGE_DELETE_REQUEST_TITLE_MESSAGE"),
                                    message: t("MESSAGE_BACKUP_IMAGE_DELETE_REQUEST_MESSAGE"),
                                    items: selectItems.map((item: any, index) => {
                                            return { target: item.vm_backup_name }
                                    }),
                                    code: "BACKUP_DELETE",
                                    cancelButtonYn: true,
                                    confirmButtonCb: confirmAction,

            });
        } else if(code === "SYNC") {
            props.setLoading(true);
            requests.post(PLATFORM_URL.VM_BACKUP + PLATFORM_URL.SYNC, {})
            .then(async (response) => {
                if (response.status === 200) {
                    props.setLoading(false);
                    AlertFunction(t("SYNC_COMPLETED_TEXT"));
                    setRefreshYn(true);
                }
            })
            .catch((error) => {
                props.setLoading(false);
            })
        } else if (code === 'BACKUP_IMAGE_DOWNLOAD') {
            selectItems?.map((v) => {
                setTimeout(()=>{
                    requestVmBackupImageDownload(v.vm_backup_id);
                }, 0);
            })
        } else if (code === 'BACKUP_RESTORE') {
            navigate(`${PAGE_URL.RESTORE_MANAGEMENT}`);
        }
    }


    function requestVmBackupImageDownload(id) {
        props.setLoading(true);

        requests.getFile(PLATFORM_URL.VM_BACKUP + '/' + id + '/download')
        .then((response) => {
            if (response.status === 200) {
                const blob = new Blob([response.data], {type: "application/octet-stream"});
                const fileUrl = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = fileUrl;
                link.style.display = 'none';
                const injectFilename = (res) => {
                    const disposition = res.headers['content-disposition'];
                    const fileName = decodeURI(
                        disposition
                        .match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/)[1]
                        .replace(/['"]/g, '')
                    );
                    return fileName;
                };
                link.download = injectFilename(response);
                link.click();
                link.remove();

            }
            props.setLoading(false);
        })
        .catch((error) => {
            AlertFunction(t("MESSAGE_CANNOT_LOAD_DATA_MESSAGE"), true);
            props.setLoading(false);
            setRefreshYn(false);
        })
    }


    function selectRow(items) {
        // !!선택 테이블인 경우 액션 메뉴 상태 변경 커스텀
        setSelectItems(items);
        if(items.length > 0) {
            setActionMenuStatus(2, true);
            setActionMenuStatus(3, true);
        } else {
            setActionMenuStatus(2, false);
            setActionMenuStatus(3, false);
        }
    }

    function clickRow(item) {
        props.showSlideModalCb({...backupRestoreModalContent, openYn: true, resultCb: restoreBackupImageResult, args: item});
    }

    function generateUiData(data) {
        console.log(data)
        return data.map((d)=> {
            if (!d.backup_image_file_exists_yn) {
                d['vm_backup_status_code'] = 'NO_EXIST';
            }
            return d;
        })
    }

    function executeLoadBackupList(pageSize, pageIndex, sortByName, sortByDescYn, categoryType, categoryCode, search, showLoading) {
        if(showLoading) {
            setCurrentPage(pageIndex);
            props.setLoading(true);
        }
        requests.get(PLATFORM_URL.VM_BACKUP, generateQueryParam(pageSize, pageIndex, sortByName, sortByDescYn, categoryType, categoryCode, search))
        .then((response) => {
            if (response.status === 200 && response.data.items && pageIndex === response.data.page-1) {
                setTableData(generateUiData(response.data.items));
                setPageCount(response.data.pages);
                setTotalItemCount(response.data.total);
            }
            if(showLoading) {
                props.setLoading(false);
                setRefreshYn(false);
            }
        })
        .catch((error) => {
            AlertFunction(t("MESSAGE_CANNOT_LOAD_DATA_MESSAGE"), true);
            if(showLoading) {
                props.setLoading(false);
                setRefreshYn(false);
            }
        })
    }


    function setActionMenuStatus(id, activeYn) {
        actionMenus[id - 1].activeYn = activeYn;
    }


    const fetchData = useCallback(({ pageSize, pageIndex, sortByName, sortByDescYn, categoryType, categoryCode, search, showLoading }) => {
        const fetchId = ++fetchIdRef.current
        if(fetchId === fetchIdRef.current) {
            executeLoadBackupList(pageSize, pageIndex, sortByName, sortByDescYn, categoryType, categoryCode, search, showLoading);
        }
    }, []);



    return (
        <>
            <BackupMgmt
                clickActionMenu={clickActionMenu}
                selectRow={selectRow}
                clickRow={clickRow}
                fetchData={fetchData}
                currentPage={currentPage}
                pageCount={pageCount}
                headers={headers}
                tableData={tableData}
                totalItemCount={totalItemCount}
                refreshYn={refreshYn}
                infoText={infoText}
                infoError={infoError}
            />
            <BackupSyncModal
                showPopupYn={showSyncPopupYn}
                closeBtnCb={()=>{
                    setShowSyncPopupYn(false);
                }}
                cancelBtnCb={()=>{
                    setShowSyncPopupYn(false);
                }}
                confirmBtnCb={(location:string, path:string)=>{
                    confirmAction("SYNC")
                    setShowSyncPopupYn(false);
                }}
            />
        </>
    )
}